import * as React from 'react';
import { Room } from '../../../../models/hotel-room-types';
import { AdaptiveType } from '../../../../models/adaptive';
import S from '../../../../stores';
import { RoomCardSidePanel } from './RoomCardSidePanel';
import { RoomCardPopup } from './RoomCardPopup';

export interface RoomCardDetailedProps {
    room: Room;
    onClose: () => void;
}

export const RoomCardDetailed = ({
    room,
    onClose,
}: RoomCardDetailedProps) => {
  const isMobile = S.ui.adaptiveType === AdaptiveType.LessThan768;

  if (isMobile) return <RoomCardSidePanel room={room} closeSidePanel={onClose} />;

  return <RoomCardPopup room={room} closePopup={onClose} />;
};
